<template>
  <a
    v-if="isAbsoluteUrl"
    :href="dynamicExternalURL"
    aria-describedby="leave-page-label"
    target="_blank"
  >
    <slot></slot>
  </a>
  <router-link
    v-else
    :to="localizedRoute"
    :tag="tag">
    <slot></slot>
  </router-link>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { isAbsoluteUrl } from '@/ts/utility.methods'
  export default defineComponent({
    props: {
      to: {
        required: false,
        type: String as () => string
      },
      tag: {
        type: String,
        required: false
      },
      leavePage: {
        type: Boolean,
        required: false
      },
    },
    computed: {
      clientID(): string {
        return this.$store.state.globals.clientId.toLowerCase()
      },
      selectedLanguage(): string {
        return this.$route.params.lang as string
      },
      computedTo(): string {
        const to = this.to || '' as string
        return to.startsWith('/') ? to.substr(1) : to
      },
      isAbsoluteUrl(): boolean {
        return isAbsoluteUrl(this.computedTo as string)
      },
      dynamicExternalURL(): string {
        const to = this.to || '' as string
        const clientID = this.clientID === 'eyemed' ? 'member' : this.clientID
        return to.replace('$EXTERNAL_SITE_URL', `${clientID}/${this.selectedLanguage}`)
      },
      localizedRoute(): string {
        return `/${this.clientID}/${this.selectedLanguage}/${this.computedTo}`
      }
    },
  })
</script>
